import React, { useState, useCallback, useEffect } from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import i18n from '../../i18n/i18n';

let _add = null;
export const toast = {
  success: (msg) => _add?.({ type: 'success', msg }),
  error:   (msg) => _add?.({ type: 'error',   msg }),
  warning: (msg) => _add?.({ type: 'warning', msg }),
  info:    (msg) => _add?.({ type: 'info',    msg }),
  confirm: (msg, onConfirm, confirmLabel = 'Confirm') =>
    _add?.({ type: 'confirm', msg, onConfirm, confirmLabel }),
};

const ICONS = {
  success: <CheckCircle size={17} />,
  error:   <XCircle size={17} />,
  warning: <AlertTriangle size={17} />,
  info:    <Info size={17} />,
  confirm: <AlertTriangle size={17} />,
};
const COLORS = {
  success: { bg: 'rgba(5,150,105,0.12)',  border: 'rgba(5,150,105,0.3)',  color: '#059669' },
  error:   { bg: 'rgba(225,29,72,0.12)',  border: 'rgba(225,29,72,0.3)',  color: '#e11d48' },
  warning: { bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.3)', color: '#d97706' },
  info:    { bg: 'rgba(37,99,235,0.12)',  border: 'rgba(37,99,235,0.3)',  color: '#2563eb' },
  confirm: { bg: 'rgba(225,29,72,0.08)',  border: 'rgba(225,29,72,0.25)', color: '#e11d48' },
};

export function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => setToasts(ts => ts.filter(x => x.id !== id)), []);

  const add = useCallback(({ type, msg, onConfirm, confirmLabel }) => {
    const id = Date.now();
    setToasts(t => [...t, { id, type, msg, onConfirm, confirmLabel }]);
    const ttl = type === 'confirm' ? 8000 : 4000;
    setTimeout(() => dismiss(id), ttl);
  }, [dismiss]);

  useEffect(() => { _add = add; return () => { _add = null; }; }, [add]);

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 10, minWidth: 300, maxWidth: 380 }}>
      {toasts.map(t => {
        const c = COLORS[t.type];
        return (
          <div key={t.id} style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.color, borderRadius: 10, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10, boxShadow: 'var(--shadow-lg)', animation: 'slideUp 200ms ease-out' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ flexShrink: 0, marginTop: 1 }}>{ICONS[t.type]}</span>
              <span style={{ flex: 1, fontSize: 14, fontWeight: 500, lineHeight: 1.4 }}>{t.msg}</span>
              <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: c.color, opacity: 0.6, padding: 0, flexShrink: 0 }}
                onClick={() => dismiss(t.id)}>
                <X size={14} />
              </button>
            </div>
            {t.type === 'confirm' && (
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button
                  onClick={() => dismiss(t.id)}
                  style={{ fontSize: 12, fontWeight: 600, padding: '5px 14px', borderRadius: 6, border: `1px solid ${c.border}`, background: 'transparent', color: c.color, cursor: 'pointer', opacity: 0.75 }}>
                  {i18n.t('cancel')}
                </button>
                <button
                  onClick={() => { t.onConfirm?.(); dismiss(t.id); }}
                  style={{ fontSize: 12, fontWeight: 700, padding: '5px 14px', borderRadius: 6, border: 'none', background: '#e11d48', color: '#fff', cursor: 'pointer' }}>
                  {t.confirmLabel}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
